import { createRoute } from '@tanstack/react-router';
import { TransporteursPage } from '@/features/carriers/transporteurs-page.js';
import { parseTransporteursSearch } from '@/features/carriers/search-params.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/transporteurs` — écran Transporteurs (`02` §9). `validateSearch` documente
 * le contrat d'URL : l'onglet actif (`?tab=regles|simulateur`) et, pour la
 * matrice de couverture, la boutique dont on lit les profils d'expédition
 * (`?store=`). Tout le reste de l'écran est de l'UI sur cette unique route —
 * voir `README-shell.md`.
 */
export const transporteursRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/transporteurs',
  validateSearch: parseTransporteursSearch,
  component: TransporteursPage,
});
